import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/home/Index'
import Login from '@/components/main/Login'
import MobileApps from '@/components/mobileapps/main/Index'
import Users from '@/components/users/users/Index'
// import StoreRequest from '@/components/store/main/StoreRequest'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {path: '/', name: 'Home', component: Home, meta: {requiresAuth: false}},
    {path: '/login', name: 'Login', component: Login, meta: {guestOnly: true}},
    {path: '/mobileapps', name: 'MobileApps', component: MobileApps, meta: {requiresAuth: false}},
    {path: '/users', name: 'Users', component: Users, meta: {requiresAuth: true}},
    // {path: '/storerequest', name: 'StoreRequest', component: StoreRequest, meta: {forAuth: true}},
  ]
})

// Add navigation guard on the router instance
router.beforeEach((to, from, next) => {
  const loggedIn = Vue.auth.isAuthenticated()
  const permissions = Vue.auth.getPermissions()

  if (to.meta.requiresAuth && !loggedIn) {
    return next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }

  if (to.meta.requiresAuth && to.path === '/users') {
    if (
      permissions.includes('View Users') ||
      permissions.includes('View Roles')
    ) {
      return next()
    }
    return next('/')
  }

  if (to.meta.guestOnly && loggedIn) {
    return next('/')
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js